import Vue from "vue"
import Router from "vue-router"
import {getCookie, setCookie} from "../utils";

Vue.use(Router)

export const fixedRoutes = [
  {
    //考试说明步骤
    path: '/entry',
    name: 'Entry',
    component: () => import("@/views/Entry"),
  },
  {
    //解析
    path: '/record',
    name: 'Record',
    component: () => import('@/views/Record/index')
  },
  {
    //解析
    path: '/collect',
    name: 'Collect',
    component: () => import('@/views/Collect/index')
  }
]

const createRouter = () => new Router({
  base: "/",
  routes: fixedRoutes
})

const router = createRouter()

//设置路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/entry'){
    let userID = to.query.userID;
    let cookie = getCookie('cdeluid') || getCookie('ssouid');
    if (!cookie && userID){
      setCookie('cdeluid', userID);
    }
  }
  // 增加userID传递
  if (!to.query.userID && from.query.userID){
    to.query.userID=from.query.userID;
    next(to);
    return;
  }
  // to要去的页面 from从哪里来 next放行
 /* const userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
  if (userID) {
    next()
  } else {
    //弹窗登录
    window.CDEL.islogin()
  }*/
  next()
})

export default router
